export default "__VITE_ASSET__jiJNu1Mq__"